module.exports = __webpack_public_path__ + "static/media/red-green.af31f333.png";